import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Box } from '@mui/material';
import userApi from '../../../../api/userApi';
import {
  StyledCard,
  StyledCardHeader,
  StyledNoDataCell,
  StyledTableCell,
  StyledTableRow,
} from './styled';
import {
  formatAmount,
  formatDate,
  formatPrice,
} from '../../../../helpers/format';

const PurchaseHistory = () => {
  const { data, isLoading, isError } = userApi.useGetPurchaseHistoryQuery();

  if (isError) {
    return <Box>error</Box>;
  }

  if (isLoading) {
    return null;
  }

  return (
    <StyledCard>
      <StyledCardHeader title="Purchase History" />
      <TableContainer>
        <Table aria-label="purchase history table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Credits</StyledTableCell>
              <StyledTableCell>Amount</StyledTableCell>
              <StyledTableCell>Date</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.length ? (
              data.map(({ total, amountCents, createdAt }, index) => (
                <StyledTableRow key={index}>
                  <StyledTableCell component="th" scope="row">
                    {formatAmount(total)}
                  </StyledTableCell>
                  <StyledTableCell>
                    {formatPrice(amountCents / 100)}
                  </StyledTableCell>
                  <StyledTableCell>{formatDate(createdAt)}</StyledTableCell>
                </StyledTableRow>
              ))
            ) : (
              <StyledTableRow>
                <StyledNoDataCell colSpan={4}>
                  No purchase history available
                </StyledNoDataCell>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </StyledCard>
  );
};

export default PurchaseHistory;
